// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"281":"ac38b764","375":"2738da00","480":"aa92fb06","553":"b9d1feb5","674":"373008ff","721":"f1e17936","890":"35732dd7","910":"60c4c7df"}[chunkId] + ".chunk.js";
};